import type { Plugin } from '@dinosband/bv-main-schema/dist/types'

export function parsePluginUUID (plugin: Plugin) {
  const words = plugin.uuid.split('--')
  const uuid = words[0]
  let version = ''
  if (words.length > 1) {
    version = words[1]
  }
  return { uuid, version }
}

export function findChannelPlugin (plugins: Plugin[], uuid: string | undefined) {
  return plugins.find((p) => {
    const parsed = parsePluginUUID(p)
    return parsed.uuid === uuid
  })
}